<template>
  <div class="container">
    <p>{{ t('airflowNote') }}</p>
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
        <GenericInput
          :input-label="t('roomWidth')"
          v-model.number="growSpaceWidthFt"
          :conversion-factors="conversionFactors.basicDistance"
        />
        <GenericInput
          :input-label="t('roomLength')"
          v-model.number="growSpaceLengthFt"
          :conversion-factors="conversionFactors.basicDistance"
        />
        <GenericInput
          :input-label="t('roomHeight')"
          v-model.number="growSpaceHeightFt"
          :conversion-factors="conversionFactors.basicDistance"
        />
        <FixedUnitInput
          :input-label="t('fanCount')"
          v-model.number="fanCount"
          :unit="t('fans')"
        />
        <FixedUnitInput
          :input-label="t('exchangeTime')"
          v-model.number="exchangeTime"
          :unit="t('minutesTotalAirFlush')"
        />

        <p>{{ t('compensationFactorNote') }}</p>

        <FixedUnitInput
          :input-label="t('carbonFilterCount')"
          v-model.number="carbonCount"
          :unit="t('filters')"
        />
        <FixedUnitInput
          :input-label="t('carbonFilterCorrection')"
          v-model.number="carbonFactor"
          :unit="t('percent')"
        />
        <FixedUnitInput
          :input-label="t('oneKWHIDLightCount')"
          v-model.number="hidLightsCount"
          :unit="t('lights')"
        />
        <FixedUnitInput
          :input-label="t('oneKWHIDLightCorrection')"
          v-model.number="hidLights1kWFactor"
          :unit="t('percent')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('roomVolumeCorrected')"
          :number="roomVolume"
          :unit="t('ftCubed')"
        />
        <FixedUnitOutput
          :output-label="t('minTotalFlow')"
          :number="flowRate"
          :unit="t('scfm')"
        />
        <FixedUnitOutput
          :output-label="t('minFanFlowEach')"
          :number="singleFanFlow"
          :unit="t('scfm')"
        />
        <i>{{ t('correctedForFiltersOrHIDLamps') }}</i>
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import GenericInput from '../inputs/GenericInput.vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { defaultRound } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      GenericInput,
      FixedUnitInput,
      FixedUnitOutput,
      EquationBlock,
    },
    setup() {
      const growSpaceWidthFt = ref(10);
      const growSpaceLengthFt = ref(10);
      const growSpaceHeightFt = ref(8);
      const fanCount = ref(2);
      const exchangeTime = ref(3);
      const carbonFactor = ref(20);
      const carbonCount = ref(0);
      const hidLights1kWFactor = ref(10);
      const hidLightsCount = ref(0);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('exhaustCalcEquations');
      });
  
      const roomVolume = computed(() => {
        const trueVolume = growSpaceWidthFt.value * growSpaceLengthFt.value * growSpaceHeightFt.value;
        const correctionFactor = carbonFactor.value * carbonCount.value + hidLights1kWFactor.value * hidLightsCount.value;
        const correctionFactorMultiplied = correctionFactor / 100 + 1;
        return trueVolume * correctionFactorMultiplied;
      });
  
      const flowRate = computed(() => {
        return defaultRound(roomVolume.value / exchangeTime.value);
      });
  
      const singleFanFlow = computed(() => {
        return defaultRound(flowRate.value / fanCount.value);
      });
  
      return {
        growSpaceWidthFt,
        growSpaceLengthFt,
        growSpaceHeightFt,
        fanCount,
        exchangeTime,
        carbonFactor,
        carbonCount,
        hidLights1kWFactor,
        hidLightsCount,
        roomVolume,
        flowRate,
        singleFanFlow,
        conversionFactors: ConversionFactors,
        equations,
        t: translations.t
      };
    },
  };
  </script>
  